import React from 'react';
import {Button} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";


export default function SettingDisplayCredential({value}) {
    const [isVisible, setIsVisible] = React.useState(false);

    return <>

        <Button
            color="link" size="sm" className="me-2"
            onMouseDown={() => setIsVisible(true)}
            onMouseUp={() => setIsVisible(false)}
            onMouseLeave={() => setIsVisible(false)}
            onBlur={() => setIsVisible(false)}
        >
            <FontAwesomeIcon icon={isVisible ? faEye : faEyeSlash}/>
        </Button>
        <strong>
            {
                isVisible ? value : value.replace(/./g, '*')
            }
        </strong>

    </>
}